import authService from "../services/authService";

function getPegaApiBaseUrl() {
  return `${process.env.REACT_APP_PEGA_BASE_URL || process.env.REACT_APP_API_BASE_URL}/api/v1/pega/prweb/api/application/v2`;
}

export const getAccessToken = async (configID, channel) => {
  try {
    const headers = authService.getAuthHeader();
    if(!headers || Object.keys(headers).length === 0) return null;
    const urlParams = new URLSearchParams();
    urlParams.set('channel', channel);
    urlParams.set('applicationId', configID);
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/pega/access-token?${urlParams.toString()}`, {
      method: 'GET',
      headers: headers
    });

    if (!response.ok) {
      console.error('Failed to get access token', await response.text());
      throw new Error('Failed to get access token');
    }

    const data = await response.json();
    return data.access_token;
  } catch (error) {
    console.error('getAccessToken error:', error);
    return null;
  }
};

export const startConversation = async (agentID, contextID, configID) => {
  const interactionID = crypto.randomUUID();

  const response = await fetch(`${getPegaApiBaseUrl()}/ai-agents/${agentID}/conversations`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authService.getAuthHeader(),
      'ApplicationId': configID,
      'channel': 'agent',
      'X-Labb-FollowID': authService.getSub(),
    },
    body: JSON.stringify({ contextID, interactionID }),
  });

  if (!response.ok) {
    throw new Error('Failed to start conversation');
  }

  return response.json();
};

export const sendMessage = async (agentID, conversationID, message, configID) => {
  const response = await fetch(`${getPegaApiBaseUrl()}/ai-agents/${agentID}/conversations/${conversationID}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...authService.getAuthHeader(),
      'ApplicationId': configID,
      'channel': 'agent',
      'X-Labb-FollowID': authService.getSub(),
    },
    body: JSON.stringify({ Request: message }),
  });

  if (!response.ok) {
    throw new Error('Failed to send message');
  }

  return response.json();
};

/**
 * Fetch the next assignment a user can action for a given case.
 * Used when a magic URL specifies action=openAssignment but only provides caseId.
 * Returns the assignment ID string, or null if none found / request failed.
 */
export const getNextAssignmentForCase = async (caseId, configId) => {
  try {
    const encodedCaseId = encodeURIComponent(caseId);
    const response = await fetch(
      `${getPegaApiBaseUrl()}/cases/${encodedCaseId}`,
      {
        method: 'GET',
        headers: {
          ...authService.getAuthHeader(),
          'ApplicationId': configId,
          'channel': 'customer',
          'X-Labb-FollowID': authService.getSub(),
        },
      }
    );
    if (!response.ok) {
      console.error('Failed to get case:', caseId, await response.text());
      return null;
    }
    const data = await response.json();
    const allAssignments = data?.data?.caseInfo?.assignments || data?.caseInfo?.assignments || data?.assignments || [];
    const assignments = allAssignments.filter(a => String(a.canPerform).toLowerCase() === 'true');
    if (assignments.length === 0) {
      console.warn('No actionable assignments found for case:', caseId);
      return null;
    }
    return assignments[0].ID;
  } catch (error) {
    console.error('getNextAssignmentForCase error:', error);
    return null;
  }
};

export const closeConversation = async (agentID, conversationID, configID) => {
  const response = await fetch(`${getPegaApiBaseUrl()}/ai-agents/${agentID}/conversations/${conversationID}/close`, {
    method: 'PUT',
    headers: {
      ...authService.getAuthHeader(),
      'ApplicationId': configID,
      'channel': 'agent',
      'X-Labb-FollowID': authService.getSub(),
    },
  });

  if (!response.ok) {
    throw new Error('Failed to close conversation');
  }

  return true;
};